document.addEventListener("DOMContentLoaded", function() {
  // --- Remove Loox review brackets ---
  const interval = setInterval(function() {
    const reviewDiv = document.querySelector('.satcb_reviews_stars');
    if (reviewDiv) {
      const ratingLabel = reviewDiv.querySelector('.loox-rating-label');
      if (ratingLabel) {
        ratingLabel.innerHTML = ratingLabel.innerHTML.replace(/\s*\(.*?\)/, '');
        clearInterval(interval);
      }
    }
  }, 500);

  // --- Function to format prices ---
  function formatPrices() {
    const priceElements = document.querySelectorAll(
      '.price__current .money, .satcb_price.money, .satcb_was_price.money'
    );

    priceElements.forEach(function(el) {
      const priceText = el.textContent.trim();

      // Only apply formatting if price contains Euro symbol €
      const isEuro = priceText.includes('€');

      if (isEuro) {
        // Match Euro price format like €149.99 or 149,99 €
        const match = priceText.match(/([€])?(\d+)[,.](\d+)/);

        if (match) {
          const currency = match[1] || '€'; // fallback just in case
          const whole = match[2];
          const fraction = match[3];

          // If it's SATCB price, wrap in inner div
          if (el.classList.contains('satcb_price') || el.classList.contains('satcb_was_price')) {
            el.innerHTML = `
              <div class="satcb_price_inner">
                <span class="price-symbol">${currency}</span><span class="price-whole">${whole}</span><span class="price-fraction">${fraction}</span>
              </div>
            `;
          } else {
            el.innerHTML = `
              <span class="price-symbol">${currency}</span><span class="price-whole">${whole}</span><span class="price-fraction">${fraction}</span>
            `;
          }
        }
      }
      // If not Euro, do nothing
    });
  }

  // --- Initial format ---
  formatPrices();

  // --- Watch for dynamic changes in normal product price ---
  const mainPriceTarget = document.querySelector('.price__current');
  if (mainPriceTarget) {
    const mainObserver = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          formatPrices();
        }
      }
    });
    mainObserver.observe(mainPriceTarget, { childList: true, subtree: true });
  }

  // --- Watch for SATCB bar appearing dynamically ---
  const bodyObserver = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.id === 'satcb_bar' || (node.querySelector && node.querySelector('#satcb_bar'))) {
          console.log('SATCB bar detected, setting up internal observer.');
          formatPrices();

          const satcbBar = document.getElementById('satcb_bar');
          if (satcbBar) {
            const satcbObserver = new MutationObserver(function(innerMutations) {
              for (const innerMutation of innerMutations) {
                if (innerMutation.type === 'childList' || innerMutation.type === 'subtree') {
                  formatPrices();
                }
              }
            });
            satcbObserver.observe(satcbBar, { childList: true, subtree: true });
          }
        }
      });
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
});
